import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  reportsSharedModelService,
} from 'app/services';
import {
  alerts,
  actionIcon,
  viewArchivedReport,
} from 'app/components/global';

import directive from './report-instance.directive';
import controller from './report-instance.controller';

import reportInstanceComment from './reportInstanceComment';
import downloadArchivedReport from '../../../../../../global/downloadArchivedReport';

export default angular.module('app.components.reports.archivedReports.reportType.archivedReportInstance', [
  loaderService,
  reportsDataService,
  reportsSharedModelService,
  alerts,
  actionIcon,
  reportInstanceComment,
  viewArchivedReport,
  downloadArchivedReport
])
  .directive('archivedReportInstance', directive)
  .controller('ArchivedReportInstanceController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportType.archivedReportInstance created');
